
/*
    Wrapper component for the externally defined Excel plugin library,
    allowing us to dynamically define the structure of the resulting file with props
    and with the schema of the data returned
*/

import React, { Suspense } from "react";

import ExcelSheet from './ExcelPlugin/elements/ExcelSheet';
import ExcelColumn from './ExcelPlugin/elements/ExcelColumn';

const ExcelFile = React.lazy(() => import('./ExcelPlugin/components/ExcelFile'));

/*
PROPS:

filename: ""

data: 
    [
        {
            name: "",
            reportSubjectLabel: ""
            records: [{},{}]
        },
        {},
        {}
    ]

filter: {
    ...values
}
*/

export default class ReportExport extends React.Component {

    hasRecords = () => {
        let ret = false;

        this.props.data.forEach((data) => {
            ret |= data.records.length > 0;
        })

        return ret;
    }

    render(){
        let sheets = [];

        // each element of the data array should be an individual sheet
        // filled with data records
        if(this.props.data.length > 0) {
            // for each sheet in the data, create an ExcelSheet component
            sheets = this.props.data.map((data, index) => {
                return (
                    <ExcelSheet data={data.records} name={data.name} key={index}>
                    {
                        data.records.length
                        ? (
                            // loop through all the keys in the first record
                            // and add an ExcelColumn to the current sheet
                            Object.keys(data.records[0]).filter(key => {
                                return !(this.props.exclude && this.props.exclude.length && this.props.exclude.includes(key));
                            }).map((key, index) => {
                                const label = (key === "ReportSubject" && data.reportSubjectLabel) 
                                    ? data.reportSubjectLabel 
                                    : key; 
                                return <ExcelColumn key={index+""} label={label} value={key} />;
                            })
                        )
                        : <ExcelColumn key={"key"} label={"ZERO RECORDS FOR THIS REPORT"} value={""} />
                    }
                    </ExcelSheet>
                ) 
            });
        }

        // add an additional sheet at the end showing all of the filter values
        // used to get the data results
        if(this.props.filter){

            const flattened_filter = {...this.props.filter};

            // flatten any arrays of values within the filter as well
            Object.keys(flattened_filter).forEach(key => {
                if(flattened_filter[key].join !== undefined){
                    flattened_filter[key] = flattened_filter[key].join(", ");
                }
            });

            sheets.push(
                    <ExcelSheet data={[flattened_filter]} name="Filter Values" key="filter">
                        {
                            Object.keys(this.props.filter).map((key, index) => {
                                return (
                                    <ExcelColumn key={index} label={key} value={key} />
                                ) 
                            })
                        }
                    </ExcelSheet>
            );
        }

        // pass the props into the ExcelFile component and let it do it's magic
        return (
            <>
            {
                sheets
                ? (
                    <Suspense fallback={<div>Loading...</div>}>
                        <ExcelFile 
                            setup={this.props.setup} 
                            filename={this.props.filename} 
                            element={<div className="option  "
                                    >
                                        Excel
                                    </div>}
                        >
                            {
                                sheets
                            }
                        </ExcelFile>
                    </Suspense>
                )
                : <div className="option  ">NO EXPORT SHEETS</div>
            }
            </>
        )
    }
};
